import './Notify.scss';
import { IPerson } from '@ms/odsp-datasources/lib/PeoplePicker';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TooltipHost, DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { ClientId, IEngagementExtraData, ISharingStore } from '../../interfaces/SharingInterfaces';
import { css } from 'office-ui-fabric-react/lib/Utilities';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as EngagementHelper from '../../utilities/EngagementHelper';
import stringResx from "../Share.resx";

export interface INotifyGroupRecipient extends IPerson {
    checked?: boolean;
    memberCount?: number;
    groupId?: number;
    disabled?: boolean;
}

export interface INotifyGroupRecipientProps {
    clientId: ClientId;
    group: INotifyGroupRecipient;
    updateCheckboxForGroup: (group: INotifyGroupRecipient) => void;
    updateCountCallback: () => void;
    engagementExtraData: IEngagementExtraData;
}

export interface INotifyGroupRecipientState {
    group: INotifyGroupRecipient;
}

export class NotifyGroupRecipient extends React.Component<INotifyGroupRecipientProps, INotifyGroupRecipientState> {
    private _sharingStore: ISharingStore;

    static contextTypes = {
        sharingStore: PropTypes.object.isRequired,
        strings: PropTypes.object.isRequired,
    };

    constructor(props: INotifyGroupRecipientProps, context: any) {
        super(props);
        this._sharingStore = context.sharingStore;

        this.state = {
            group: props.group
        };
    }

    public componentWillMount() {
        this._sharingStore.fetchMemberCount(this.props.group);
    }

    public componentDidMount() {
        this._sharingStore.addListener(this.props.updateCountCallback);
    }

    @autobind
    private _onCheckboxChange(ev: React.FormEvent<HTMLElement>, isChecked: boolean) {
        let group = this.props.group;
        group.checked = isChecked;
        this.setState({ group: group }, () => {
            EngagementHelper._log('Notify.GroupCheckboxClicked', this.props.engagementExtraData);
            this.props.updateCountCallback();
            this.props.updateCheckboxForGroup(group);
        });

    }

    @autobind
    private _renderGroup(): JSX.Element {
        const group = this.state.group;
        const isDisabled = group.disabled;
        return (
            <Checkbox
                id={ group.email }
                boxSide={ 'start' }
                label={ isDisabled ? group.name + " (" + stringResx.notifyGroupReachedAllowedLimit + ")" : group.name }
                checked={ group.checked }
                defaultChecked={ false }
                onChange={ this._onCheckboxChange }
                className={ css('od-Notify-group-checkbox') }
                disabled={ group.disabled }
            >
            </Checkbox>
        );
    }

    render(): React.ReactElement<{}> {
        const group = this.state.group;
        const isDisabled = group.disabled;
        return (
            <TooltipHost
                className={ css('od-Notify-group-recipient') }
                id={ group.email }
                content={ isDisabled ? group.name + " (" + stringResx.notifyGroupReachedAllowedLimit + ")" : group.name }
                directionalHint={ DirectionalHint.bottomCenter }
            >
                { this._renderGroup() }
            </TooltipHost>
        );
    }
}